import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { appApiHandler } from "../../api/appApiHandler";
import CommonHeader from "../../components/header/CommonHeader";
import EmptyState from "../../components/EmptyState";
import InlineLoader from "../../components/loader/InlineLoader";
import NotificationCard from "./component/notificationCard";
import { BsBell } from "react-icons/bs";
import "./Notifications.css";

import { useNavigate } from "react-router-dom";
import CommonFooter from "../../components/footer/CommonFooter";
import { FaUser } from "react-icons/fa";

const Notifications = () => {
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.userState);
  const { isLoggedIn } = useSelector((state) => state.authState);

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const getNotifications = async () => {
    const reqData = {
      user_id: userData?._id,
    };
    const response = await appApiHandler.getNotifications(reqData);
    if (response?.status === 200 && response?.data) {
      setNotifications(response?.data);
    }
    setLoading(false);
  };

  const onPressNotification = (item) => {
    if (item?.order_id) {
      navigate("/order-details", {
        state: { orderId: item?.order_id, fromNotification: true },
      });
    } else if (item?.product_id) {
      const productUrl = `/product?product_id=${item?.product_id}`;
      window.open(productUrl, "_blank");
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      setLoading(true);
      getNotifications();
    }
  }, [isLoggedIn]);

  return (
    <div className="page-container">
    
      <div className="page-content">
        <CommonHeader title="Notification" />
        {!isLoggedIn ? (
          <EmptyState
            icon={FaUser}
            title="Sign In to Continue"
            description="please login with your account. Enjoy a seamless shopping experience with personalized recommendations and more!"
            buttonText="Login"
            onButtonClick={() => navigate("/login")}
            iconSize={48}
          />
        ) : loading ? (
          <div className="page-content">
            <div className="notifications-content">
              <InlineLoader text="Loading notifications..." />
            </div>
          </div>
        ) : (
          <div className="page-content">
            <div className="notifications-content">
              <div className="notifications-list">
                {notifications.length > 0 ? (
                  notifications.map((item, index) => (
                    <NotificationCard
                      key={index}
                      item={item}
                      onPress={onPressNotification}
                    />
                  ))
                ) : (
                  <EmptyState
                    icon={BsBell}
                    description="You're all caught up. We'll notify you when there's something new."
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <CommonFooter />
    </div>
  );
};

export default Notifications;
